import React from "react";
import { Horizontal } from "./social-share";

export function HorizontalColor(props) {
  return <Horizontal {...props} />;
}
